import { useEffect } from 'react';

import { newTracker } from '@snowplow/browser-tracker';

const COLLECTOR_TIMEOUT_MS = 5000;

type Fetch = (request: Request, init?: RequestInit) => Promise<Response>;

// Snowplow's own timer console.errors on timeout; a fetch aborted before it is retried silently.
const withTimeout = (fetchFn: Fetch) => (request: Request) => {
  const controller = new AbortController();

  request.signal.addEventListener('abort', () => {
    controller.abort(request.signal.reason);
  }, { once: true });

  // Not cleared on response: the cutoff also covers Snowplow reading the body.
  setTimeout(() => {
    controller.abort(new DOMException('Collector request timed out', 'TimeoutError'));
  }, COLLECTOR_TIMEOUT_MS);

  return fetchFn(request, { signal: controller.signal });
};

export const Snowplow = ({ fetchFn = globalThis.fetch }: { fetchFn?: Fetch }) => {
  useEffect(() => {
    const isProd = globalThis.location.hostname === 'driver.motorway.co.uk';
    const COLLECTOR = isProd ? 'laptime' : 'laptime.stage';

    newTracker('sp1', `https://${COLLECTOR}.motorway.co.uk`, {
      appId: `dealer-website-${isProd ? 'prod' : 'test'}`,
      bufferSize: 0,
      // Backstop only: Snowplow's timer must fire after ours or it logs.
      connectionTimeout: COLLECTOR_TIMEOUT_MS * 2,
      cookieSameSite: 'Lax',
      customFetch: withTimeout(fetchFn),
      discoverRootDomain: false,
      keepalive: true,
      plugins: [],
    });
  }, [fetchFn]);

  return null;
};
